import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDateFnsModule } from '@angular/material-date-fns-adapter';
import { TextInputComponent } from './text-input.component';
import { DateInputComponent } from './date-input.component';
import { SelectInputComponent } from './select-input.component';
import { RadioInputComponent } from './radio-input.component';
import { PhoneInputComponent } from './phone-input.component';
import { TextAreaComponent } from './text-area.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { enAU } from 'date-fns/locale';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { PasswordInputComponent } from './password-input.component';

@NgModule({
  declarations: [
    TextInputComponent,
    DateInputComponent,
    SelectInputComponent,
    RadioInputComponent,
    PhoneInputComponent,
    TextAreaComponent,
    FileUploadComponent,
    PasswordInputComponent
      
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatRadioModule,
    MatDatepickerModule,
    MatDateFnsModule,
    MatIconModule,
    MatButtonModule
  ],
  exports: [
    TextInputComponent,
    DateInputComponent,
    SelectInputComponent,
    RadioInputComponent,
    PhoneInputComponent,
    TextAreaComponent,
    FileUploadComponent,
    PasswordInputComponent
  ],
   providers: [
    {provide: MAT_DATE_LOCALE, useValue: enAU}
   ]
})
export class FormFieldsModule {}
